import React, { useState, useEffect } from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import { MdOutlineCurrencyRupee } from 'react-icons/md';
import { useNavigate, useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';
import celebrationAnimation from '../Celebration.json';
import Lottie from 'lottie-react';
import OfferModal from './offermodal';

// Notification Component
const Notification = ({ message, type, onClose }) => {
  const bgColor =
    type === 'success'
      ? '#48bb78' // bg-green-500
      : type === 'error'
        ? '#f56565' // bg-red-500
        : '#4299e1'; // bg-blue-500

  const notificationStyle = {
    position: 'fixed',
    top: '1.25rem', // 20px, top-5
    right: '1.25rem', // 20px, right-5
    zIndex: 50,
    padding: '1rem', // 16px, p-4
    borderRadius: '0.5rem', // 6px, rounded-lg
    boxShadow:
      '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)', // shadow-lg
    color: 'white',
    backgroundColor: bgColor,
    animation: 'fadeIn 0.5s ease-in-out',
  };

  const flexContainerStyle = {
    display: 'flex',
    alignItems: 'center',
  };

  const closeButtonStyle = {
    marginLeft: '1rem', // 16px, ml-4
    fontSize: '1.25rem', // 20px, text-xl
    border: 'none',
    background: 'none',
    color: 'white',
    cursor: 'pointer',
  };

  const iconStyle = {
    marginRight: '0.75rem', // 12px, mr-3
  };

  const fadeInStyle = `
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(-20px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `;

  return (
    <div style={notificationStyle}>
      <style>{fadeInStyle}</style>
      <div style={flexContainerStyle}>
        <span style={iconStyle}>{type === 'success' ? '✓' : '⚠'}</span>
        <span>{message}</span>
        <button onClick={onClose} style={closeButtonStyle}>
          &times;
        </button>
      </div>
    </div>
  );
};

const BuyCoins = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [pack, setPack] = useState(3);
  const [profile, setprofile] = useState([]);
  const [price, setPrice] = useState([]);
  const [config, setConfig] = useState([]);
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);
  const secretId = useParams().secretId;
  const [showOfferModal, setShowOfferModal] = useState(false);
  const [mainPack, setMainPack] = useState(null);
  const [offerPack, setOfferPack] = useState(null);
  const [selectedModalPack, setSelectedModalPack] = useState(null);
  const [showShoutPopup, setShowShoutPopup] = useState(false);
  useEffect(() => {
    setLoading(false); // reset on every route change
  }, [location.pathname]);
  // Show notification and auto-close after 3 seconds
  const showNotification = (message, type) => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  const OnPackChange = ind => {
    setPack(ind);
  };

  function goBack() {
    localStorage.setItem('mainInd', 1);
    window.location.reload();
  }

  useEffect(() => {
    if (secretId && secretId === '756e7232-2fcb-4801-98e6-c450fb0ab828') {
      const isDeepEntry = window.history.length <= 2;
      localStorage.setItem('isDeepEntry', isDeepEntry);
      setPack(4);
      return;
    }
    if (secretId) {
      console.error('Invalid secretId');
      navigate('/main');
      return;
    }
  }, [secretId]);

  useEffect(() => {
    if (pack === 4 && price.length > 0) {
      makeOrder();
    }
  }, [pack, price.length]);

  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }

      try {
        const response = await fetchWithAuth(API_ENDPOINTS.USERS, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) throw new Error('Failed to fetch data');

        const data = await response.json();
        setprofile(data);
      } catch (error) {
        console.error('Error fetching profile:', error);
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
    const fetchPrice = async () => {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }

      try {
        const priceresponse = await fetchWithAuth(API_ENDPOINTS.ORDER_PRICE, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!priceresponse.ok) throw new Error('Failed to fetch price');

        const data = await priceresponse.json();
        setPrice(data);
        console.log('data', data);
      } catch (error) {
        console.error('Error fetching prices:', error);
      }
    };

    fetchPrice();
  }, []);

  useEffect(() => {
    const fetchConfig = async () => {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }

      try {
        const configresponse = await fetchWithAuth(API_ENDPOINTS.ORDER_CONFIG, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!configresponse.ok) throw new Error('Failed to fetch config');

        const data = await configresponse.json();
        setConfig(data);
      } catch (error) {
        console.error('Error fetching config:', error);
      }
    };

    fetchConfig();
  }, []);

  const loadRazorpay = async () => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);
  };

  useEffect(() => {
    loadRazorpay();
  }, []);

  const [selectedPriceId, setSelectedPriceId] = useState(null);

  // Update when pack changes
  useEffect(() => {
    if (price.length > 0 && pack > 0) {
      setSelectedPriceId(price[pack - 1]?.id);
    }
  }, [pack, price]);

  const makeOrder = async (selectedPriceId = null) => {
    setLoading(true);
    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      setLoading(false);
      return;
    }

    // Find price item by id - use the passed selectedPriceId first
    const priceIdToUse = selectedPriceId || price[pack - 1]?.id;
    const priceItem = price.find(p => p.id === priceIdToUse);

    if (!priceItem) {
      console.error('Price item not found');
      setLoading(false);
      return;
    }

    try {
      const orderresponse = await fetchWithAuth(API_ENDPOINTS.ORDER, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          priceId: priceIdToUse, // Use the correct price ID here
        }),
      });

      if (!orderresponse.ok) throw new Error('Failed to create order');

      const data = await orderresponse.json();
      handlePayment(data, priceItem.price); // Use price from the found item
    } catch (error) {
      console.error('Error creating order:', error);
      showNotification('Failed to create order', 'error');
      setLoading(false);
    }
  };
  const phoneNumber = localStorage.getItem('number') || '';
  const handlePayment = (data, price) => {
    const options = {
      key: config.key_id,
      amount: price,
      currency: 'INR',
      name: 'Tringbox',
      description: 'Coin Transaction',
      order_id: data.order_id,
      prefill: {
        contact: phoneNumber,
      },
      handler: function (response) {
        showNotification('Payment Successful!', 'success');
        window.location.reload();
        clearLoadingState();
      },
      notes: {
        address: 'Razorpay Corporate Office',
      },
      theme: {
        color: '#CC151E',
      },
      method: {
        upi: true,
        card: false,
        netbanking: false,
        wallet: false,
        emi: false,
        paylater: false,
      },
    };

    const rzp = new window.Razorpay(options);

    rzp.on('payment.failed', function () {
      showNotification('Payment Failed!', 'error');
      clearLoadingState();
    });

    rzp.on('modal.close', function () {
      console.log('Modal closed by user.');
      clearLoadingState();
    });

    rzp.open();

    // Optional: If Razorpay modal is blocked or doesn't show
    setTimeout(() => {
      clearLoadingState();
    }, 30000); // Fallback after 15 seconds
  };

  const clearLoadingState = () => {
    setLoading(false);
  };
  useEffect(() => {
    // Razorpay modal closes via browser back or manual exit
    const resetOnBack = () => {
      setLoading(false);
    };

    window.addEventListener('focus', resetOnBack);
    return () => {
      window.removeEventListener('focus', resetOnBack);
    };
  }, []);

  const handleUserHistory = () => {
    navigate('/history');
  };

  useEffect(() => {
    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      navigate('/');
      return;
    }
  }, [navigate]);

  const handlePackClick = async i => {
    try {
      const clickedPack = price[i];
      console.log('current-pack', clickedPack);

      const token = localStorage.getItem('tringAuthToken');

      if (clickedPack?.offerPriceId) {
        const response = await fetch(
          API_ENDPOINTS.ORDER_PRICE_BY_ID(clickedPack.offerPriceId),
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (!response.ok) {
          throw new Error(`API error: ${response.status}`);
        }
      }

      setPack(i + 1);
      setSelectedPriceId(price[i].id);
    } catch (error) {
      console.error('Error in handlePackClick:', error);
    }
  };

  return (
    <div
      style={{
        padding: '0 16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '91.5dvh', // Adjust this to account for navbar
        width: '100%',
        maxWidth: '420px',
        margin: '0 auto',
        paddingBottom: '80px', // Adjust padding to prevent overlap with navbar
        boxSizing: 'border-box',
        overflow: 'auto',
      }}
    >
      {/* Notification component */}
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}

      {showShoutPopup && (
        <div
          className="shout-popup"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 3000,
            pointerEvents: 'none',
          }}
        >
          <div
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
            }}
          >
            <Lottie
              animationData={celebrationAnimation}
              loop={false}
              autoplay={true}
            />
          </div>
        </div>
      )}

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          marginBottom: '8px',
          marginTop: '16px',
          maxWidth: '400px',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <h4 style={{ margin: 0 }}>
            <IoIosArrowBack
              style={{ marginRight: '10px' }}
              onClick={() => goBack()}
            />
          </h4>
          <h4 style={{ margin: 0, color: '#D0151C' }}>Buy Coins</h4>
        </div>
        <button
          onClick={handleUserHistory}
          style={{
            border: 'none',
            color: 'gray',
            background: 'none',
            cursor: 'pointer',
          }}
        >
          View History
        </button>
      </div>

      <div
        className="w-100 my-2 d-flex flex-column align-items-start justify-content-center text-start"
        style={{
          backgroundImage: 'url(/images/buycoins.gif)',
          backgroundPosition: 'center',
          backgroundRepeat: 'none',
          backgroundSize: '100% 100%',
          height: '20dvh',
          minHeight: '20dvh',
          color: 'white',
          paddingLeft: '40vw',
        }}
      >
        <h4 style={{ margin: 0, marginBottom: '8px' }}>You Have</h4>
        <span
          style={{
            color: '#FED111',
            fontSize: 'clamp(0px,4.5vw,20px)',
          }}
        >
          <b>{profile.coins || 0}</b>
          <span style={{ color: '#FFF', fontSize: 'clamp(0px,4vw,18px)' }}>
            {' '}
            Tring Coins
          </span>
        </span>
      </div>

      {price.length === 0 ? (
        <div>Loading...</div>
      ) : (
        <div
          style={{
            marginBottom: '8px',
            marginTop: '10px',
            display: 'grid',
            gridTemplateRows: 'repeat(3, auto)',
            gap: '14px',
            padding: '16px 8px',
            position: 'relative',
            border: '2px solid #BF1A2A',
            borderRadius: '10px',
            maxWidth: '400px',
            width: '100%',
            flex: 1,
          }}
        >
          {[0, 1, 2].map(i => (
            <div
              key={i}
              onClick={() => handlePackClick(i)}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '16px',
                border: '1px solid #D9D9D9',
                borderRadius: '8px',
                minHeight: '90px',
                position: 'relative',
                cursor: 'pointer',
                backgroundColor: '#fff',
              }}
            >
              {/* Popular Badge */}
              {i === 2 && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    padding: '2px 6px',
                    borderRadius: '4px',
                    background: 'linear-gradient(90deg, #FEDA23, #FEA902)',
                    fontSize: '12px',
                    color: '#fff',
                    fontWeight: 600,
                  }}
                >
                  Popular
                </div>
              )}

              {/* Discount Badge */}
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  padding: '2px 6px',
                  borderRadius: '0 4px 0 0',
                  background: 'linear-gradient(90deg, #CC151E, #873662)',
                  fontSize: '12px',
                  color: '#fff',
                  fontWeight: 600,
                }}
              >
                {Math.round(
                  ((price[i].display_price - price[i].price) /
                    price[i].display_price) *
                    100
                )}
                %
              </div>

              {/* Left Section */}
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
              >
                {/* Radio Circle */}
                <div
                  style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    border: `2px solid ${
                      pack === i + 1 ? '#BF1A2A' : '#9D9D9D'
                    }`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <div
                    style={{
                      width: '10px',
                      height: '10px',
                      borderRadius: '50%',
                      backgroundColor: pack === i + 1 ? '#BF1A2A' : '#fff',
                    }}
                  />
                </div>

                {/* Coin Image */}
                <img
                  src={`/images/${[2, 10, 20][i]}coins.png`}
                  alt="coin"
                  style={{
                    width: '35px',
                    height: '35px',
                    objectFit: 'contain',
                  }}
                />

                {/* Coin Info */}
                <div>
                  <div style={{ fontSize: '16px', fontWeight: 600 }}>
                    {price[i].coins} Coins
                  </div>
                  <div style={{ fontSize: '13px', color: '#9D9D9D' }}>
                    ( Upto {price[i].songs}{' '}
                    {price[i].songs === 1 ? 'Request' : 'Requests'} )
                  </div>
                </div>
              </div>

              {/* Right Section */}
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: '20px', fontWeight: 700 }}>
                  ₹{price[i].price}
                </div>
                <div
                  style={{
                    fontSize: '13px',
                    textDecoration: 'line-through',
                    color: '#9D9D9D',
                  }}
                >
                  ₹{price[i].display_price}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <button
        style={{
          width: '100%',
          padding: '8px 16px',
          marginTop: '1px',
          fontSize: 'clamp(0px,5vw,22px)',
          borderRadius: '10px',
          background:
            'linear-gradient(90deg, #CC151E -18.35%, #873662 108.23%)',
          color: 'white',
          border: 'none',
          maxWidth: '400px',
          position: 'relative',
        }}
        onClick={() => makeOrder(selectedPriceId)}
        disabled={loading || !selectedPriceId}
      >
        Continue
      </button>
    </div>
  );
};

export default BuyCoins;
